import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

function ProtectedRoute({ children, allowedRoles }) {
  const { user, selectedRole } = useAuth();
  
  if (!user) {
    return <Navigate to="/welcome" replace />;
  }

  // Role-based access control
  if (allowedRoles && !allowedRoles.includes(selectedRole)) {
    // Redirect to appropriate default page based on current role
    if (selectedRole === 'super_admin') {
      return <Navigate to="/users-dashboard" replace />;
    } else if (selectedRole === 'institute_admin') {
      return <Navigate to="/admin-dashboard" replace />;
    } else if (selectedRole === 'instructor') {
      return <Navigate to="/courses" replace />;
    }
    // Fallback to welcome for unknown roles
    return <Navigate to="/welcome" replace />;
  }
  
  return children;
}

export default ProtectedRoute;

